export const categories = [
  {
    id: 'wanghong-bagua',
    name: '网红八卦',
    slug: 'wanghong-bagua',
    icon: 'ri-user-smile-line',
    description: '最新网红圈八卦爆料，一手掌握主播达人私密动态',
  },
  {
    id: 'mingxing-tafang',
    name: '明星塌房',
    slug: 'mingxing-tafang',
    icon: 'ri-home-smile-line',
    description: '明星人设崩塌现场直击，还原塌房事件真相',
  },
  {
    id: 'heiliao-baoliao',
    name: '黑料爆料',
    slug: 'heiliao-baoliao',
    icon: 'ri-fire-line',
    description: '独家黑料深度挖掘，内幕消息抢先看',
  },
  {
    id: 'zongyi-chigua',
    name: '综艺吃瓜',
    slug: 'zongyi-chigua',
    icon: 'ri-tv-line',
    description: '综艺节目幕后故事，嘉宾之间的爱恨情仇',
  },
  {
    id: 'yingshi-bagua',
    name: '影视八卦',
    slug: 'yingshi-bagua',
    icon: 'ri-film-line',
    description: '影视圈新片动态、演员八卦、剧组趣闻全收录',
  },
  {
    id: 'hulianwang-gua',
    name: '互联网瓜',
    slug: 'hulianwang-gua',
    icon: 'ri-global-line',
    description: '互联网大厂八卦、科技圈热点、创业者故事',
  },
];

export const trendingTags = [
  '顶流塌房',
  '恋情曝光',
  '综艺名场面',
  '深夜发文',
  '律师函警告',
  '工作室声明',
  '大瓜预警',
  '反转再反转',
];